import { type App } from 'vue';

function setupDirectives(app: App) {}

export default setupDirectives;

export { setupDirectives };
